import React from 'react';
import ClientView from 'components/layout/client/ClientView';

export default class ClientDetails extends React.Component {
  render() {
    return <ClientView clientId={this.props.match.params.clientId} editClient />;
  }
}
